import type { FeedbackItem, FeedbackScreen, SubmitFeedbackInput } from '../index.js'
import { apiGet, apiPost } from '../../core/index.js'

/**
 * What the feedback button needs from whichever app it sits in. The
 * operator app sends through the bearer-token client; the admin area,
 * which has no bearer token, sends through its Basic Auth adapter.
 */
export interface FeedbackApi {
  area: FeedbackScreen['area']
  submit(input: SubmitFeedbackInput): Promise<FeedbackItem>
  /** What this person's client has sent so far, with how each item was resolved. */
  listMine(): Promise<FeedbackItem[]>
  /** Where the list is cached, so a submission can refresh it. */
  queryKey: readonly string[]
}

export const operatorFeedbackApi: FeedbackApi = {
  area: 'operator',
  submit: (input) => apiPost<FeedbackItem>('/feedback', input),
  listMine: () => apiGet<FeedbackItem[]>('/feedback'),
  queryKey: ['feedback', 'mine'],
}

/**
 * A worker's own login may send feedback but not read the client's list
 * (`GET /feedback` is the operator's), so the drawer shows nothing sent.
 */
export const workerFeedbackApi: FeedbackApi = {
  area: 'worker',
  submit: (input) => apiPost<FeedbackItem>('/feedback', input),
  listMine: async () => [],
  queryKey: ['feedback', 'mine', 'worker'],
}
